import React, { useRef, useState, useEffect } from 'react';
import { IonModal, IonSlides, IonSlide, IonItem, IonInput, IonButton, IonGrid, IonRadio, IonRow, IonCol, IonText, IonContent, IonButtons, IonFooter} from '@ionic/react';

import '../../css/layout.css';

import {JobDescriptionModal} from '../components/Modal_JobDescription';


export function Jobs(props) {

    let [baseURL, setBaseURL ] = useState(window.location.origin+"/");
    const [acctID, setAcctID ] = useState('G1');

    let [noRequisitions, setNoRequisitions] = useState(true);
    let [viewRequisitionsetailData, setViewRequisitionsetailData] = useState([]);

    let [requisitionID, setRequisitionID] = useState(false);
    let [requisitionName, setRequisitionName] = useState(false);
    let [requisitionResponsibilites, setRequisitionResponsibilites] = useState(false);
    let [requisitionQualifications, setRequisitionQualifications] = useState(false);
    let [requisitionDeadline, setRequisitionDeadline] = useState(false);

    let [showJobDescriptionModal, setShowJobDescriptionModal] = useState(false);

    useEffect(() => {


        if(props.openModal == true)
        {

            let formData = new FormData();
            formData.append('Tracker', '74503_view_jobReqList_public');
            formData.append('user', acctID);
            //formData.append('xCheckInRoomID', props.data.requisitionID);
        
        
            const requestOptions = {
                enctype: 'multipart/form-data',
                method:'POST',
                credentials: 'include',
                files: formData,
                body: formData,
                contentType: false,
                processData: false,
            }
        

            //alert(baseURL);

            
            let newBaseURL = 'https://ghanaverified.com';
            if(baseURL == 'https://bluefinhoteltest.com/' || baseURL == 'https://bluefinhoteltest.com/overviewTab')
            {
                newBaseURL = 'https://ghanaverifiedtest.com'
            }

            //alert(baseURL);
            //fetch(newBaseURL+'/public_request', requestOptions)
            fetch(baseURL+'ghanaverified/', requestOptions)
            .then(res => res.text())
            .then(res => {
        
                let rows = res.toString().split('~~~');

                if(rows.length > 0)
                {
                    setNoRequisitions(false);
                }
        
                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');


                    setViewRequisitionsetailData((prevViewRequisitionsetailData) => {
                        return prevViewRequisitionsetailData.concat({
                            requisitionID: cols[0],
                            companyRole: cols[1],
                            requisitionName: cols[2],
                            requisitionResponsibilites: cols[3],
                            requisitionQualifications: cols[4],
                            requisitionDeadline: cols[5],
                            dateCreated: cols[6],
                        })

                    });
        
                }    
            })
        }
    }, []);

    function viewJobDescriptionModalHandler(event)
    {
        setRequisitionID(event[1]);
        setRequisitionName(event[2]);
        setRequisitionResponsibilites(event[3]);
        setRequisitionQualifications(event[4]);
        setRequisitionDeadline(event[5]);

        setShowJobDescriptionModal(event[0]);
    }

    function closeModalHandler() {

        props.closeModal(false);
    }

    return (
    <React.Fragment>
    {props.data.status != 'ghanaverified_site' &&
            <IonContent className='appContent' id='qavaAppConfirmed'>
                <IonGrid> 

                    <IonRow className='gridResultHeaders'>
                            <IonCol className='gridResultColumns'>Requistion ID</IonCol>
                            <IonCol className='gridResultColumns'>Requistion Name</IonCol>
                            <IonCol className='gridResultColumns'>Action</IonCol>
                    </IonRow>
                    <IonRow></IonRow>
                    <IonRow></IonRow>

                        {viewRequisitionsetailData.map((detailData) =>   {
                                return (
                                    <IonRow className='gridResultBody' key={detailData.requisitionID}>
                                        <IonCol className='gridResultColumns'>{detailData.requisitionID}</IonCol>
                                        <IonCol className='gridResultColumns'>{detailData.requisitionName}</IonCol>
                                        <IonCol className='gridResultColumns'>
                                            <IonButton className='gridResultColumnButton' onClick={() => viewJobDescriptionModalHandler([true, detailData.requisitionID, detailData.requisitionName, detailData.requisitionResponsibilites, detailData.requisitionQualifications, detailData.requisitionDeadline])}> View </IonButton>
                                        </IonCol>
                                    </IonRow>
                                )
                            }
                        )}

                    {noRequisitions == true &&
                        <IonRow>
                            <IonCol>
                                <h3> No Postions Available</h3>
                            </IonCol>
                        </IonRow>  
                    }    
                </IonGrid>

            </IonContent>
        }

        {props.data.status == 'ghanaverified_site' &&
            
            <IonModal isOpen={ props.openModal }>
            <IonContent className='appContent' id='qavaAppConfirmed'>

                <IonGrid> 

                <IonRow className='gridResultHeaders'>
                        <IonCol className='gridResultColumns'>Requistion ID</IonCol>
                        <IonCol className='gridResultColumns'>Requistion Name</IonCol>
                        <IonCol className='gridResultColumns'>Action</IonCol>
                </IonRow>
                <IonRow></IonRow>
                <IonRow></IonRow>

                    {viewRequisitionsetailData.map((detailData) =>   {
                            return (
                                <IonRow className='gridResultBody' key={detailData.requisitionID}>
                                    <IonCol className='gridResultColumns'>{detailData.requisitionID}</IonCol>
                                    <IonCol className='gridResultColumns'>{detailData.requisitionName}</IonCol>
                                    <IonCol className='gridResultColumns'>
                                        <IonButton className='gridResultColumnButton' onClick={() => viewJobDescriptionModalHandler([true, detailData.requisitionID, detailData.requisitionName, detailData.requisitionResponsibilites, detailData.requisitionQualifications, detailData.requisitionDeadline])}> View </IonButton>
                                    </IonCol>
                                </IonRow>
                            )
                        }
                    )}

                {noRequisitions == true &&
                    <IonRow>
                        <IonCol>
                            <h3> No Postions Available</h3>
                        </IonCol>
                    </IonRow>  
                }    
                </IonGrid>
                </IonContent>
                <IonFooter className='grid_footer'>
                    <IonGrid>
                        <IonCol>
                            <IonButton onClick={closeModalHandler}>Cancel </IonButton>
                        </IonCol>
                    </IonGrid>
                </IonFooter>
            </IonModal>
        }

        {showJobDescriptionModal == true && 
                <JobDescriptionModal openModal={ showJobDescriptionModal } closeModal={() => setShowJobDescriptionModal(false)} data={{
                    requisitionID: requisitionID, 
                    requisitionName: requisitionName,
                    requisitionResponsibilites: requisitionResponsibilites,
                    requisitionQualifications: requisitionQualifications,
                    requisitionDeadline: requisitionDeadline,
                                        }}></JobDescriptionModal>
        }

    </React.Fragment>
    )
}

export default Jobs;